<template>
  <div class="bottom-box">
    <div class="fill-box"></div>
    <div class="bottom-int">
      <div class="bottom-top">
        <div class="top-box">
          <div class="top-box-left">
            <div style="width: 300px;">
              <img style="width: 100%;" src="../../static/images/logowhite.png"/>
            </div>
            <div>
              电话：0571-89150039
            </div>
            <div>
              传真：0571-89150039
            </div>
            <div>
              地址：浙江省杭州市临平区星桥街道星桥北路64号4幢601室
            </div>
          </div>
          <div class="top-box-right">
            <div class="top-right-item">
              <div class="top-right-item-tit">
                关于盛弘
              </div>
              <div class="pointer" @click="skipPage('/aboutUs')">
                公司简介
              </div>
            </div>
            <div class="top-right-item">
              <div class="top-right-item-tit">
                服务项目
              </div>
              <div class="pointer" @click="skipPage('/occupationalHygiene')">
                职业卫生检测与评价
              </div>
              <div class="pointer" @click="skipPage('/safetyAssessment')">
                安全技术服务
              </div>
              <div class="pointer" @click="skipPage('/environmentDetection')">
                环保技术服务
              </div>
            </div>
            <div class="top-right-item">
              <div class="top-right-item-tit">
                信息公开
              </div>
              <div class="pointer" @click="skipPage('/reports')">
                职业卫生报告
              </div>
              <div class="pointer" @click="skipPage('/publicNotice')">
                信息公示
              </div>
              <div class="pointer" @click="skipPage('/newsList')">
                新闻资讯
              </div>
            </div>
            <div class="top-right-item">
              <div class="top-right-item-tit">
                联系我们
              </div>
              <div class="pointer" @click="skipPage('/contactUs')">
                联系我们
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bot">
        <div class="bottom-bot-box display_space">
          <div class="display_start">
            Copyright © 2021-2022  杭州盛弘检测科技有限公司 All Rights Reserved.
          </div>
          <div class="display_end">
            ICP备案号：
            <a href="http://beian.miit.gov.cn/" target="_blank" style="color:#bebebd;">浙ICP备2022019943号-1</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods:{
    skipPage(pagePath){
      this.$router.push(pagePath)
    }
  }
}
</script>

<style scoped lang="less">
  .bottom-box{
    width: 100%;
    .fill-box{
      width: 100%;
    }
    .bottom-int{
      height: 360px;
      width: 100%;
      .bottom-top{
        width: 100%;
        height: 300px;
        background: #34373a;
        display: flex;
        align-items: center;
        justify-content: center;
        .top-box{
          width: 1200px;
          color: #d0d0d0;
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          .top-box-left{
            line-height: 32px;
            width: 360px;
            padding-right: 40px;
            height: 200px;
            border-right: 1px #494b4e solid;
          }
          .top-box-right{
            padding-left: 40px;
            line-height: 30px;
            display: flex;
            .top-right-item{
              height: 200px;
              width: 170px;
              .top-right-item-tit{
                font-size: 16px;
                color: #FFFFFF;
                margin-bottom: 12px;
              }
              div{
                color: #bfc0c0;
              }
            }
          }
        }
      }
      .bottom-bot{
        width: 100%;
        height: 60px;
        background: #2b2b29;
        display: flex;
        align-items: center;
        justify-content: center;
        .bottom-bot-box{
          width: 1200px;
          div{
            height: 60px;
            font-size: 14px;
            color: #bebebd;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue